import React from 'react';
import { useParams } from 'react-router';
import NavBar from '../components/layout/NavBar';
import Footer from '../components/layout/Footer';
import CheckoutPage from '../components/checkout/CheckoutPage';

function CheckoutView() {
    const { id } = useParams();

    return (
        <div className="checkout-view-wrapper" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#0B0C0E', color: '#F8F8F2' }}>
            <NavBar />
            <main className="flex-grow-1 flex align-items-center justify-content-center p-4">
                <div style={{ width: '100%', maxWidth: '600px' }}>
                    <CheckoutPage inscricaoId={id} />
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default CheckoutView;
